const routes = [
  {
    path: "/student/teacherSatisfactionQuestionnaire",
    name: "teacherSatisfactionQuestionnaire",
    component: () => import("@/views/student/teacherSatisfactionQuestionnaire/Main.vue")
  }
];

export default routes;
